/**
 * WorkFocus brand mark — wraps the real `LogoFusion.svg` extracted
 * from the legacy `wf-audit/src/slices/common/assets/`. The asset
 * lives in `/public/LogoFusion.svg`; this component just sizes it.
 */
export function BrandMark({
  size = 48,
  className,
}: {
  size?: number;
  className?: string;
}): JSX.Element {
  return (
    <img
      src="/LogoFusion.svg"
      alt="WorkFocus"
      width={size}
      height={size}
      className={className}
      style={{ width: size, height: size }}
    />
  );
}
